exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".TrackControls {\n  display: flex;\n  flex-direction: column;\n  height: 344px; }\n  .TrackControls-volumeSlider {\n    flex-grow: 1;\n    width: 100%; }\n  .TrackControls-toggles {\n    margin-top: 12px;\n    margin-bottom: 0; }\n    .TrackControls-toggles .Button {\n      display: block;\n      width: 100%; }\n  .TrackControls.is-enabled .TrackControlsLabel {\n    cursor: pointer; }\n    .TrackControls.is-enabled .TrackControlsLabel:hover {\n      color: #0068e9; }\n  .TrackControls:not(.is-enabled) .TrackControlsLabel {\n    color: #9ea0a3; }\n  .TrackControls.is-selected .TrackControlsLabel {\n    color: #0068e9; }\n", ""]);

// exports
